var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group flex"},[_c('input',_vm._g(_vm._b({ref:"input",staticClass:"py-2",attrs:{"type":"file"}},'input',_vm.$attrs,false),_vm.$listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }